/**
 * «FOTOS Y MEDIDAS», LA ÚLTIMA SECCIÓN DEL MENSUAL (rediseño del 28-10, maqueta 3).
 *
 *     TUS FOTOS
 *     ┌ Mismas condiciones que el mes pasado: misma luz, misma hora y mismo momento del día.
 *     │ [ De frente ↑ ] [ De perfil ↑ ] [ De espaldas ↑ ]
 *     TUS MEDIDAS CORPORALES
 *     ┌ [▶ Vídeo tutorial · cómo tomar los perímetros]
 *     │ Cintura                       82 · 84 el mes pasado
 *     │ Cadera                        98 · 99
 *     │ ...
 *     [ENVIAR]                         (lo pone el formulario)
 *
 * Las fotos se suben solas, cada una en su petición (`TresFotos`); las medidas viajan con el
 * envío. Las diez son obligatorias (`lib/medidas.revisarMedidas` y el servidor).
 *
 * LOS RÓTULOS DE LAS FOTOS LLEVAN EL «DE» (Jesús, 9-09; ver `TresFotos`): la maqueta pone
 * «Frente · Perfil · Espalda», pero él pidió expresamente «De espaldas».
 */
import React, { useState } from 'react';
import TresFotos from './TresFotos';
import { MEDIDAS, VIDEO_MEDIDAS, valorAnterior } from '../../lib/medidas';

const ORANGE = '#FF671F';

const Rotulo = ({ children }) => (
    <p className="text-[11px] font-bold uppercase tracking-wider" style={{ color: ORANGE }}>{children}</p>
);

const coma = (v) => String(v).replace('.', ',');

/**
 * EL BLOQUE DE LAS DIEZ MEDIDAS, CON SU VÍDEO. Lo comparten este paso y el check-in diario
 * (02-11): la misma pantalla en los dos sitios. `medidas` es {clave: valor}; `anteriores`, las
 * de la toma de antes (o nada); `rotuloAnterior` es lo que acompaña a la primera de ellas.
 */
export const TusMedidas = ({ medidas, onCambio, anteriores, rotuloAnterior = ' el mes pasado' }) => {
    const [video, setVideo] = useState(false);
    return (
        <div className="rounded-2xl bg-card border p-4" style={{ borderColor: ORANGE }} data-testid="medidas">
            <button type="button" onClick={() => setVideo((v) => !v)} data-testid="video-medidas-boton"
                className="w-full rounded-xl border border-border py-3 text-sm font-bold text-foreground hover:border-foreground/30">
                ▶ Vídeo tutorial · cómo tomar los perímetros
            </button>
            {video && (
                <div className="mt-3 rounded-xl overflow-hidden bg-black" style={{ aspectRatio: '16 / 9' }}>
                    <iframe src={VIDEO_MEDIDAS} title="Cómo medir los perímetros"
                        allow="fullscreen; picture-in-picture" data-testid="video-medidas"
                        className="w-full h-full border-0" />
                </div>
            )}

            <div className="mt-2">
                {MEDIDAS.map(({ key, label }, i) => {
                    const antes = valorAnterior(anteriores, key);
                    return (
                        <label key={key} htmlFor={`medida-${key}`}
                            className={`flex items-center justify-between gap-3 py-2.5 ${i ? 'border-t border-border' : ''}`}>
                            <span className="text-sm text-foreground/80">{label}</span>
                            <span className="flex items-baseline gap-1.5 shrink-0">
                                <input id={`medida-${key}`}
                                    type="number" step="0.1" inputMode="decimal"
                                    value={medidas?.[key] ?? ''}
                                    onChange={(e) => onCambio({ ...medidas, [key]: e.target.value })}
                                    placeholder="—" data-testid={`medida-${key}`}
                                    className="w-14 bg-transparent text-right text-base font-bold text-foreground placeholder:text-foreground/60 outline-none focus:text-[#FF671F]" />
                                {antes != null && (
                                    <span className="text-[11px] text-muted-foreground tabular-nums whitespace-nowrap">
                                        · {coma(antes)}{i === 0 ? rotuloAnterior : ''}
                                    </span>
                                )}
                            </span>
                        </label>
                    );
                })}
            </div>
        </div>
    );
};

const MensualPaso3 = ({ api, token, valores, set, prev, plazo }) => {
    return (
        <div className="space-y-4" data-testid="mensual-paso3">
            <div className="space-y-2" data-testid="mensual-fotos">
                <Rotulo>Tus fotos</Rotulo>
                <TresFotos api={api} token={token} esMensual compacta />
            </div>

            {plazo?.cierre && (
                <p className="text-[13px] text-muted-foreground" data-testid="paso3-plazo">
                    Tienes como fecha límite <b className="text-foreground">{plazo.cuando || plazo.cierre}</b>
                    {plazo.queda ? ` · ${plazo.queda}` : ''}.
                </p>
            )}

            <div className="space-y-2">
                <Rotulo>Tus medidas corporales</Rotulo>
                <TusMedidas medidas={valores.measurements} anteriores={prev?.measurements}
                    onCambio={(m) => set('measurements', m)} />
            </div>
        </div>
    );
};

export default MensualPaso3;
